import { Button } from "@fox/atoms";
import { FlexColumnSpaced } from "@fox/layout";
import MUIAlert from "@mui/material/Alert";
import React from "react";
import { useContentContext } from "../../content-context";
import { MemberShipFormTemplate } from "../membership-form-template";
import { MembershipFormFieldTypes } from "../membership-form-template/contracts";
import { redirect } from "../membership-form-template/util";
import { IPasswordResetFormProps, PasswordResetFormModel } from "./contracts";
import { passwordResetValidationSchema } from "./validation-schema";

export const PasswordResetForm: React.FC<IPasswordResetFormProps> = ({
	token,
	memberId,
	loginPageUrl,
	isNewSignUp,
}) => {
	const { contentId, requestToken } = useContentContext();
	if (!token || !memberId) {
		return (
			<MUIAlert severity="error">
				Password reset can only be done via link sent via email!
			</MUIAlert>
		);
	}
	return (
		<MemberShipFormTemplate<PasswordResetFormModel>
			contentId={contentId}
			recaptcha="memberPasswordReset"
			submitButtonText="Reset Password"
			validationSchema={passwordResetValidationSchema}
			initialValues={{ token, memberId, password: "" }}
			successMessage={
				<FlexColumnSpaced style={{ maxWidth: "max-content", margin: "0 auto" }}>
					<MUIAlert severity="success">
						{isNewSignUp
							? "Account successfully registered"
							: "Password successfully updated"}
					</MUIAlert>
					<Button
						variant="primary"
						onClick={() => {
							redirect(loginPageUrl);
						}}
					>
						Log in
					</Button>
				</FlexColumnSpaced>
			}
			submitFunction={async (values) => {
				return await fetch("/Umbraco/Api/Membership/SubmitPasswordReset", {
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						RequestVerificationToken: requestToken,
					},
					body: JSON.stringify({ ...values, contentId }),
				});
			}}
			fields={[
				{
					name: "password",
					label: "New password",
					fieldType: MembershipFormFieldTypes.PasswordFieldWithStrength,
				},

				{
					name: "confirmPassword",
					label: "Repeat new password",
					fieldType: MembershipFormFieldTypes.PasswordField,
				},
			]}
		/>
	);
};
